import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TKubunListGetRes, TKubunListGetReq } from "./TKubun"

/**
 * 社員マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class KubunService
 * @extends {ConnectApi}
 */
export default class KubunService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TKubunListGetReq} params
   * @memberof MenuService
   */
  getList = async (params?: TKubunListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKubunListGetRes[]>> =
        await this.getInner(`/master/kubun`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
